import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { post } from "../../services/api";
import logo from "../../assets/img/logo-full.png";

function Sidebar() {
  const [sidebarData, setSidebarData] = useState([]);
  const [filteredSidebarData, setFilteredSidebarData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const token = localStorage.getItem("token");
  const roleId = localStorage.getItem("roleId");

  const orgLogoPath = localStorage.getItem("organizationLogoPath");
  const centerLogoPath = localStorage.getItem("centerLogoPath");

  const orgLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${orgLogoPath}`;
  const centerLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${centerLogoPath}`;

  const sidebarLogo =
    roleId == "2" ? orgLogo : roleId == "3" ? centerLogo : orgLogo || centerLogo || logo;

  const handleSidebarToggle = () => {
    document
      .querySelector("html")
      .classList.toggle("navbar-vertical-collapsed");
  };

  const username = localStorage.getItem("username");

  useEffect(() => {
    const fetchSidebarMenu = async () => {
      try {
        const formData = { id: roleId };

        const response = await post(
          `UserAuthentication/GetRolePermissionByRoleId`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Manually inject Billing Report into the Sidebar's Billing section
        const updatedSidebar = response?.sidebar.map(category => {
          if (category.categoryName.toLowerCase().includes("billing")) {
            return {
              ...category,
              subCategories: category.subCategories.map(subCat => {
                if (subCat.subCategoryName.toLowerCase().includes("billing")) {
                  // Check if form already exists to avoid duplicates
                  if (!subCat.forms.find(f => f.formPath === "billing-report")) {
                    return {
                      ...subCat,
                      forms: [
                        ...subCat.forms,
                        {
                          formId: "manual-billing-report",
                          formName: "Billing Report",
                          formPath: "billing-report",
                          icon: "fas fa-file-invoice-dollar",
                          isCompleted: false
                        }
                      ]
                    };
                  }
                }
                return subCat;
              })
            };
          }
          return category;
        });

        setSidebarData(updatedSidebar || response?.sidebar);
        setFilteredSidebarData(updatedSidebar || response?.sidebar);
      } catch (error) {
        console.error("Error fetching sidebar menu:", error);
      }
    };

    if (!roleId || roleId === "null") {
      console.log("Invalid roleId");
    } else {
      fetchSidebarMenu();
    }
  }, [roleId]);

  useEffect(() => {
    const filterSidebarData = () => {
      if (!searchTerm.trim()) {
        setFilteredSidebarData(sidebarData);
        return;
      }

      const lowerSearchTerm = searchTerm.toLowerCase();
      const filteredData = sidebarData
        .map((category) => {
          const matchesCategory = category.categoryName
            .toLowerCase()
            .includes(lowerSearchTerm);

          const filteredSubCategories = category.subCategories
            .map((subCategory) => {
              const matchesSubCategory = subCategory.subCategoryName
                .toLowerCase()
                .includes(lowerSearchTerm);

              const filteredForms = subCategory.forms.filter((form) =>
                form.formName.toLowerCase().includes(lowerSearchTerm),
              );

              return {
                ...subCategory,
                forms: filteredForms,
                isMatch: matchesSubCategory || filteredForms.length > 0,
              };
            })
            .filter((subCategory) => subCategory.isMatch || matchesCategory);

          return {
            ...category,
            subCategories: filteredSubCategories,
            isMatch: matchesCategory || filteredSubCategories.length > 0,
          };
        })
        .filter((category) => category.isMatch);

      setFilteredSidebarData(filteredData);
    };

    filterSidebarData();
  }, [searchTerm, sidebarData]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };

  const handleCloseSidebar = () => {
    if (window.innerWidth < 992) {
      const navbarVerticalCollapse = document.getElementById(
        "navbarVerticalCollapse",
      );
      if (navbarVerticalCollapse) {
        navbarVerticalCollapse.classList.remove("show");
      }
    }
  };

  const renderMenu = () => {
    return filteredSidebarData.map((category) => (
      <div className="nav-item-wrapper" key={category.categoryId}>
        <a
          className="nav-link dropdown-indicator label-1"
          href={`#cat-${category.categoryName
            .toLowerCase()
            .replace(/\s+/g, "-")}`}
          role="button"
          data-bs-toggle="collapse"
          aria-expanded={searchTerm ? "true" : "true"}
          aria-controls={`cat-${category.categoryName
            .toLowerCase()
            .replace(/\s+/g, "-")}`}
        >
          <div className="d-flex align-items-center">
            <div className="dropdown-indicator-icon-wrapper">
              <span className="fas fa-caret-right dropdown-indicator-icon"></span>
            </div>
            <span className="nav-link-icon">
              {category.icon && <span className={category.icon}></span>}
            </span>
            <span className="nav-link-text">{category.categoryName}</span>
          </div>
        </a>

        <div className="parent-wrapper label-1">
          <ul
            className={`nav collapse parent ${searchTerm ? "show" : "show"}`}
            id={`cat-${category.categoryName
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
          >
            {category.subCategories.map((subCategory) => (
              <li className="nav-item" key={subCategory.subCategoryId}>
                <a
                  className="nav-link dropdown-indicator label-1"
                  href={`#subcat-${subCategory.subCategoryName
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  role="button"
                  data-bs-toggle="collapse"
                  aria-expanded={searchTerm ? "true" : "false"}
                  aria-controls={`subcat-${subCategory.subCategoryName
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <div className="d-flex align-items-center">
                    <div className="dropdown-indicator-icon-wrapper">
                      <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                    </div>
                    <span className="nav-link-icon">
                      {subCategory.icon && (
                        <span className={subCategory.icon}></span>
                      )}
                    </span>
                    <span className="nav-link-text ps-0">
                      {subCategory.subCategoryName}
                    </span>
                  </div>
                </a>

                <ul
                  className={`nav collapse parent ${searchTerm ? "show" : ""}`}
                  id={`subcat-${subCategory.subCategoryName
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  {subCategory.forms.map((form) => (
                    <li className="nav-item" key={form.formId}>
                      <NavLink
                        onClick={handleCloseSidebar}
                        className={({ isActive }) =>
                          isActive ? "active nav-link" : "nav-link"
                        }
                        to={
                          form.formPath ||
                          `/${form.formName.toLowerCase().replace(/\s+/g, "-")}`
                        }
                        target={
                          form.formName === "Reporting Tool"
                            ? "_blank"
                            : "_self"
                        }
                      >
                        <div className="d-flex align-items-center">
                          {form.icon && (
                            <span
                              className={`nav-link-icon ${form.icon}`}
                            ></span>
                          )}
                          {form.isCompleted ? (
                            <>
                              <span
                                className="d-inline-block"
                                style={{ width: "10px" }}
                              >
                                <span className="fas fa-check-circle text-success"></span>
                              </span>
                              <span className="nav-link-text ps-2">
                                {form.formName}
                              </span>
                            </>
                          ) : (
                            <span className="nav-link-text">
                              {form.formName}
                            </span>
                          )}
                        </div>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ));
  };

  return (
    <nav className="navbar navbar-vertical navbar-expand-lg bg-white">
      <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
        <NavLink className="mt-2 mb-1 d-lg-flex d-none" to={"dashboard"}>
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              <img
                src={sidebarLogo}
                alt="Logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}
                width="100%"
                height="50"
                style={{ objectFit: "contain" }}
              />
            </div>
          </div>
        </NavLink>

        <div className="navbar-vertical-content">
          <div
            className="my-1 px-3"
            style={{
              position: "sticky",
              top: "0",
              zIndex: "1",
            }}
          >
            <div className="position-relative">
              <input
                type="text"
                className="form-control px-2"
                placeholder="Search Menu"
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ borderRadius: "15px" }}
              />
              {searchTerm ? (
                <button
                  className="btn btn-link position-absolute"
                  style={{
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    padding: "0",
                    lineHeight: "0",
                  }}
                  onClick={clearSearch}
                  title="Clear Seach"
                >
                  <span className="fas fa-times"></span>
                </button>
              ) : (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                  }}
                >
                  <i className="fas fa-search text-black-50 fs-9"></i>
                </div>
              )}
            </div>
          </div>
          <ul className="navbar-nav flex-column" id="navbarVerticalNav">
            <li className="nav-item">{renderMenu()}</li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Sidebar;
